export default __webpack_public_path__ + "static/272-04c5b5ff3721f6b2fc7ca25f14e087ae.gif";